import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import all page components
import HomePage from './pages/HomePage';
import FlightBooking from './pages/FlightBooking';
import HotelBooking from './pages/HotelBooking';
import ApartmentBooking from './pages/ApartmentBooking';
import AirportPickup from './pages/AirportPickup';
import CarRental from './pages/CarRental';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/flight-booking" element={<FlightBooking />} />
            <Route path="/hotel-booking" element={<HotelBooking />} />
            <Route path="/apartment-booking" element={<ApartmentBooking />} />
            <Route path="/airport-pickup" element={<AirportPickup />} />
            <Route path="/car-rental" element={<CarRental />} />
          </Routes>
        </main>
        <Footer />
      </Router>
    </div>
  );
}

export default App;